import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';

import { JwlTable } from '../../../../components';
import { GQLAccessoryModel, GQLParty } from '@jewelutions/core-crm-server-api-client-domain';
import AccessoryModelCreateDialog from '../AccessoryModelCreateDialog';
import { PlatformNavigation } from '../../navigation/PlatformNavigation';
import { successNotification } from '../../../../core/utils';
import { toast } from 'react-toastify';

interface IProps {
  party: GQLParty;
  accessoryId: string;
  accessoryModels: GQLAccessoryModel[];
}

const columns = ['Size', 'Publishable', 'Availability'];

const AccessoryModelsList: React.FC<IProps> = ({ party, accessoryId, accessoryModels }: IProps) => {
  const history = useHistory();
  const [data, setData] = useState([] as any[]);
  const [isCreateAccessoryModelDialogOpen, setIsCreateAccessoryModelDialogOpen] = useState(false);

  useEffect(() => {
    const mappedValues = accessoryModels.map(model => {
      const materials: string[] = Array.from(
        new Set<string>(
          model.availableConfigurations.map(avConf => {
            return avConf.materialType;
          })
        )
      );
      const availability = materials
        .map((material: string) => {
          return `${material} (${model.availableConfigurations
            .filter(avConf => avConf.materialType === material)
            .map(avConf => avConf.platingType)
            .join()})`;
        })
        .join(';');
      return {
        ...model,
        isPublishable: model.isPublishable ? 'YES' : 'NO',
        image: `3/3`,
        availability
      };
    });

    setData(mappedValues);
  }, [accessoryModels]);

  let isAddButtonDisabled = false;
  const sizes = data.map(a => Array.from(new Set(a.availableConfigurations.map((b: any) => b.sizeType))));
  if (sizes.length > 0) {
    const diffSizes = Array.from(new Set(sizes.map(a => a[0])));
    isAddButtonDisabled = diffSizes.length >= 3;
  }

  const navigateToAccessoryModelDetails = (accessoryModelId: string) => {
    history.push(
      PlatformNavigation.accessoryModelDetails.pathFromParams({
        accessoryId: accessoryId,
        accessoryModelId: accessoryModelId
      })
    );
  };

  const getAccessoryModelsRows = () => {
    return (
      data &&
      data.map((accessoryModel: any) => {
        return {
          id: accessoryModel.id,
          cells: [accessoryModel.sizeType, accessoryModel.isPublishable, accessoryModel.availability]
        };
      })
    );
  };

  return (
    <Fragment>
      <JwlTable
        title="Accessory Models Table"
        description="If you have been reading the overrides documentation page but you are, add more metadata..."
        columns={columns}
        rows={getAccessoryModelsRows()}
        onTableRowClick={navigateToAccessoryModelDetails}
        children={
          <Button
            variant="contained"
            color="primary"
            disabled={isAddButtonDisabled}
            onClick={() => {
              setIsCreateAccessoryModelDialogOpen(true);
            }}
          >
            <AddIcon />
            Add Accessory Model
          </Button>
        }
      />
      {isCreateAccessoryModelDialogOpen && (
        <AccessoryModelCreateDialog
          accessoryId={accessoryId}
          party={party}
          onClose={success => {
            if (success === true) {
              successNotification(toast, 'Accessory model created successfully', () => {});
            }

            setIsCreateAccessoryModelDialogOpen(false);
          }}
        />
      )}
    </Fragment>
  );
};
export default AccessoryModelsList;
